import VueVirtualScroller from 'vue-virtual-scroller'
import VueLazyLoad from 'vue-lazyload'
import { createPinia } from 'pinia'
import { VueQueryPlugin } from '@tanstack/vue-query'

import VeeValidate from '@/vplugins/VeeValidate'
import MaRequests from '@/vplugins/MaRequests'
import Highcharts from '@/vplugins/Highcharts'
import router from '@/router'
import { initSentry } from '@/plugins/sentry'
import Segment from '@/plugins/segment'
import '@/plugins/ag-grid/license-manager'
import { maEnv } from '@/lib/env'
import { MaVueErrorHandler } from '@/base/MaErrorHandlers'
import { maLogger } from '@/base/logger'
import { queryClient } from '@/api/query-client'
import HubspotPlugin from './hubspot'

const DUMMY_IMG_SRC = `${maEnv.VITE_APP_MA_CDN_BASE_URL}/public/icons/ma-on-error-icon.png`

export function installPlugins(app) {
  app.config.errorHandler = MaVueErrorHandler
  initSentry(app, router)

  app.use(router)

  app.use(VueQueryPlugin, {
    queryClient,
    enableDevtoolsV6Plugin: true,
  })

  const pinia = createPinia()
  app.use(pinia)

  app.use(VueVirtualScroller)
  app.use(VueLazyLoad, {
    error: DUMMY_IMG_SRC,
    loading: DUMMY_IMG_SRC,
    lifecycle: {
      error: (el, ...args) => {
        maLogger.warn('lazy-load image error', el, args)
      },
    },
  })

  app.use(MaRequests)
  app.use(Segment, {
    segmentKey: maEnv.VITE_SEGMENT_WRITE_KEY,
    vueRouter: router,
  })
  app.use(VeeValidate)
  app.use(Highcharts)

  app.use(HubspotPlugin, {
    portalId: maEnv.VITE_HUBSPOT_PORTAL_ID,
    router,
  })
}
